
import {
    disclosureComplete, 
    disclosureInProgress, 
    disclosureNotStarted, 
    primarySeller,
    disclosureStatus} from '@helpers/order';

const getters = {
    
    getOrdersNotYetOnboarded: (state) => {
        return state._allAssociatedOrders.filter(w => !w.eulaAcceptedAt);
    },

    // this will return an array of OrderAppResource objects
    getAllAssociatedOrders: (state) => {
        return state._allAssociatedOrders;
    },
    getSelectedOrder: (state) => {
        return state._selectedOrderDetails;
    },
    getAssignedFormsForSelectedOrder: (state) => {
        return state._selectedOrderDetails?.forms?.appResources;
    },
    

    // shold we break these into separate stores? 
    // OrderDisclosureStore
    getSelectedOrderDisclosureStatus: (state) => {
        return disclosureStatus(state._selectedOrderDetails);
    },

    // JotFormDisclosureSessionStore
    getJotFormDisclosureSessionsForSelectedOrder: (state) => {
        return state._selectedOrderDetails?.disclosure?.jotFormDisclosureSessions?.appResources;
    },

    // PrimarySellerStore
    getSellersForSelectedOrder: (state) => {
        return state._selectedOrderDetails?.sellers?.appResources;
    },
    getPrimarySellerForSelectedOrder: (state) => {
        return primarySeller(state._selectedOrderDetails);
    }

};

export default getters;
